SOURCES = ['delivery_club', 'external_site', 'external_site_mobile', 'marketplace', 'marketplace_mobile', 'board', 'mobile_application_ios', 'mobile_application_android', 'foodfox', 'obed_ru', 'broniboy', 'chibbis', 'glovo', 'vk', 'sbermarket', 'yandex_lavka']

App.PromosTableComponent = Em.Component.extend
  classNames: ['promos-table']

  sort: 'is_active'
  sortAscending: true
  sortByIsActive      : Em.computed.equal 'sort', 'is_active'
  sortByName          : Em.computed.equal 'sort', 'name'
  sortByActualTill    : Em.computed.equal 'sort', 'actual_till'
  sortByRestaurants   : Em.computed.equal 'sort', 'restaurants'
  sortBySources       : Em.computed.equal 'sort', 'sources'
  sortByPriority      : Em.computed.equal 'sort', 'priority'
  sortByVisibility    : Em.computed.equal 'sort', 'visibility'

  sources: (->
    SOURCES.map (source) =>
      id:  source
      name: Em.I18n.t "clients.order_source.#{source}"
  ).property('sources')

  activity: (->
    filters = ['active', 'not_active']
    filters.map (filter) =>
      return {
        id: filter
        is_active: filter is 'active'
        name: Em.I18n.t "promos.table.filters.is_active.#{filter}"
      }
  ).property('activity')

  deliveryTypes: (->
    filters = ['is_takeaway', 'is_delivery', 'is_dine_in']
    filters.map (filter) =>
      return {
        id: filter
        name: Em.I18n.t "promos.edit.#{filter}"
      }
  ).property('deliveryTypes')

  isFiltersVisible: false
  selectedRestaurants: []
  selectedDeliveryTypes: []
  selectedSources: []
  selectedActiveFilter: null
  activeFrom: null
  activeTill: null
  searchQuery: ''

  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  debounceSearchQuery: (->
    Em.run.cancel @get('debouncedSearchQueryTimeout')
    if Em.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery','')
      return
    @set('debouncedSearchQueryTimeout', Em.run.later @, ->
      @set('debouncedSearchQuery', @get('searchQuery'))
      @set('debouncedSearchQueryTimeout',null)
    , 2000)
  ).observes('searchQuery')


  activeFromOWBinding: Em.Binding.oneWay('activeFrom')
  activeTillOWBinding: Em.Binding.oneWay('activeTill')

  tableHeadings: (->
    headings = [
      { sortBy: 'name', heading: 'promos.table.content.name' },
      { sortBy: 'is_active', heading: 'promos.table.content.is_working' },
      { sortBy: 'actual_till', heading: 'promos.table.content.actual_till' },
      { sortBy: 'restaurants', heading: 'promos.table.content.restaraunt' },
      { sortBy: 'sources', heading: 'promos.table.content.sources' },
      { sortBy: 'priority', heading: 'promos.table.content.priority' },
      { sortBy: 'visibility', heading: 'promos.table.content.visibility'}
    ]

    headings.forEach (heading) =>
      camelizedHeading = _.camelCase(heading.sortBy)
      formattedHeading = "#{camelizedHeading.charAt(0).toUpperCase()}#{camelizedHeading.slice(1)}"
      heading.sorted = @get("sortBy#{formattedHeading}")
    headings
  ).property('sort')

  filterQueryPromos: (->
    # Получаем значения выбранных фильтров
    selectedOrderSourcesValues = @get('selectedSources').map (r) -> Em.get(r, 'id')
    selectedDeliveryTypes = @get('selectedDeliveryTypes').map (t) -> Em.get(t, 'id')
    restaurantIds = @get('selectedRestaurants').map (r) -> Em.get(r, 'id')
    selectedActiveFilter = @get('selectedActiveFilter')?.is_active
    searchQuery = @get('debouncedSearchQuery')?.toLowerCase()
    activeFrom = @get('activeFrom')
    activeTill = @get('activeTill')

    # Преобразуем даты в формат ISO для сравнения
    if !Em.isEmpty(activeFrom)
      activeFrom = moment(activeFrom).hours(0).minutes(0).toISOString()
    if !Em.isEmpty(activeTill)
      activeTill = moment(activeTill).hours(23).minutes(59).toISOString()

    # Получаем оригинальный массив промо
    promos = @get('mappedPromos') || []

    # Применяем фильтры
    filteredPromos = promos.filter (promo) ->
      matchedFilters = []
      if !Em.isEmpty(selectedDeliveryTypes)
        matchedFilters.push(selectedDeliveryTypes.some (type) => promo.get(type))
      # Фильтрация по источникам заказа
      if !Em.isEmpty(selectedOrderSourcesValues)
        sources = promo.get('sources')?.split(',') || []
        matchedFilters.push(sources.some (source) => selectedOrderSourcesValues.includes(source))

      # Фильтрация по ресторанам
      if !Em.isEmpty(restaurantIds)
        matchedFilters.push(restaurantIds.some (id) => promo.get('restaurantsIds')?.includes(id))

      # Фильтрация по статусу активности
      if selectedActiveFilter?
        matchedFilters.push(promo.get('is_active') is selectedActiveFilter)

      # Фильтрация по строке поиска
      if !Em.isEmpty(searchQuery)
        promoName = promo.get('name')?.toLowerCase() || ''
        matchedFilters.push(promoName.includes(searchQuery))

      # Фильтрация по диапазону дат
      if !Em.isEmpty(activeFrom) or !Em.isEmpty(activeTill)
        promoTill = promo.get('actual_till')
        if not promoTill
          matchedFilters.push(false)
        else
          matchedFilters.push(moment(promoTill).isBetween(activeFrom || moment().toISOString(), activeTill || moment().toISOString(), null, '[]'))

      # Проверяем, соответствует ли элемент всем фильтрам
      matchedFilters.every (el) => el

    # Возвращаем отфильтрованный массив
    filteredPromos
  ).property(
    'selectedDeliveryTypes.[]'
    'mappedPromos.[]',
    'selectedSources.[]',
    'selectedRestaurants.[]',
    'selectedActiveFilter',
    'debouncedSearchQuery',
    'activeFrom',
    'activeTill'
  )



  didInsertElement: ->
    @send('sortBy', @get('sort'))

  mappedPromos: (->
    promos = @get('promos')
    return [] unless promos
    promos.forEach (promo) =>
      arrOfDeliveryRestricts = [
        {
          id: 'is_takeaway',
          enabled: promo.get('is_takeaway')
        },
        {
          id: 'is_dine_in',
          enabled: promo.get('is_dine_in')
        },
        {
          id: 'is_delivery'
          enabled: promo.get('is_delivery')
        }
      ]
      promo.get('restaurants').then (rests) =>
        return unless rests
        restaurantsText = rests.map (rest) =>
          rest.get('name')
        .join(', ')
        restaurantsIds = rests.map (rest) =>
          rest.get('id')

        promo.set('restaurantsText', restaurantsText)
        promo.set('restaurantsIds', restaurantsIds)

      if promo.get('sources')
        promo.set('promosSourcesText', promo.get('sources').split(',').map (source) =>
          Em.I18n.t "clients.order_source.#{source}"
        )
      if promo.get('actual_till')
        promo.set('is_active', moment(promo.get('actual_till')) > moment() and promo.get('is_working'))
      else
        promo.set('is_active', promo.get('is_working') and arrOfDeliveryRestricts.some (rule) => rule.enabled)

      arrOfDeliveryRestrictsText = []
      arrOfDeliveryRestricts.map (rule) =>
        if rule.enabled
          text = Em.I18n.t "promos.edit.#{rule.id}"
          arrOfDeliveryRestrictsText.push "#{text}"
      promo.set('restrictsText', arrOfDeliveryRestrictsText.join(',\n'))
    promos
  ).property('promos.[]')


  actions:
    sortBy: (propertyName) ->
      currentSort = @get 'sort'
      sortAscending = @get 'sortAscending'

      # Если уже сортируем по текущему столбцу, инвертируем направление
      if currentSort is propertyName
        @toggleProperty 'sortAscending'
        sortAscending = @get 'sortAscending'
      else
        # Устанавливаем новый ключ сортировки и по умолчанию сортируем по возрастанию
        @set 'sort', propertyName
        @set 'sortAscending', true
        sortAscending = true

      # Получаем список промо и сортируем их
      promos = @get 'mappedPromos'

      # Обрабатываем сортировку, учитывая случаи, когда значение отсутствует
      sortedPromos = _.sortBy(promos.toArray(), (el) ->
        value = if propertyName is 'visibility' then [el.get('is_takeaway'), el.get('is_delivery'), el.get('is_dine_in')] else el.get(propertyName)
        # Устанавливаем значение для отсутствующих данных, чтобы они сортировались корректно
        if value? then value else (if sortAscending then Infinity else -Infinity)
      )

      # Если требуется сортировка по убыванию, инвертируем массив
      unless sortAscending
        sortedPromos = sortedPromos.reverse()

      # Обновляем список промо
      @set 'mappedPromos', sortedPromos

      false

    openPromo: (promo) ->
      @sendAction('openPromo', promo)
      false

    toggleFilters: ->
      @toggleProperty('isFiltersVisible')
      false

    updateActiveFrom: (val) ->
      @set('activeFrom', val)
      false

    updateActiveTill: (val) ->
      @set('activeTill', val)
      false



